"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InfoboxField = function InfoboxField(props) {
  var name = props.name,
      value = props.value,
      classNames = props.classNames,
      highlight = props.highlight,
      icon = props.icon,
      children = props.children;
  var combinedClassNames = "infobox-field ".concat(highlight ? 'highlight' : '', " ").concat(classNames ? classNames.reduce(function (acc, curr) {
    return "".concat(acc, " ").concat(curr);
  }) : '');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: combinedClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'infobox-field-icon'
  }, icon), /*#__PURE__*/_react.default.createElement("div", {
    className: 'infobox-field-group'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'infobox-field-name'
  }, name), /*#__PURE__*/_react.default.createElement("span", {
    className: 'infobox-field-value'
  }, value || children, "\xA0")));
};

InfoboxField.propTypes = {
  name: _propTypes.default.string.isRequired,
  children: _propTypes.default.element,
  value: _propTypes.default.string,
  icon: _propTypes.default.element,
  highlight: _propTypes.default.bool,
  classNames: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = InfoboxField;
exports.default = _default;